export default {
  list: [],
  loading: true,
  currentProfile: {},
  keywords: {},
  filteredList: []
};
